/**
 *  @class
 *  @function PredictiveSearch
 */
class PredictiveSearch {
  constructor() {
    this.container = document.getElementById('Search-Drawer');
    this.cloneContainer = this.container.cloneNode(true);
    this.form = this.container.querySelector('.search-drawer--searchform');
    this.button = document.querySelectorAll('.thb-quick-search');
    this.input = this.container.querySelector('input[type="search"]');
    this.predictiveSearchResultsWrapper = this.container.querySelector('.search-drawer--inner');
    this.predictiveSearchResults = this.predictiveSearchResultsWrapper.querySelector('.thb-predictive-search');
    this.total = 0;
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.form.addEventListener('submit', this.onFormSubmit.bind(this));

    this.input.addEventListener('input', debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.button.forEach((item, i) => {
      item.addEventListener('click', (event) => {
        var _this = this;
        this.container.classList.add('active');
        event.preventDefault();
        document.body.classList.toggle('open-search');
        document.body.classList.toggle('open-cc');
        if (document.body.classList.contains('open-search')) {
          setTimeout(function () {
            _this.input.focus({
              preventScroll: true
            });
          }, 100);
          dispatchCustomEvent('search:open');
        }

        return false;
      });
    });
  }

  getQuery() {
    return this.input.value.trim();
  }

  onChange() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.container.classList.add('active');
      this.predictiveSearchResults.innerHTML = this.cloneContainer.querySelector('.thb-predictive-search').innerHTML;
      window.webyzeMultiProductColorsLoad?.();
      return;
    }
    this.container.classList.add('active');
    // this.getSearchResults(searchTerm);
    this.getSearchResultsWithType(searchTerm);

  }

  onFormSubmit(event) {
    if (!this.getQuery().length) {
      event.preventDefault();
    }
  }

  onFocus() {
    const searchTerm = this.getQuery();

    if (!searchTerm.length) {
      this.getSearchResults(searchTerm);
      return;
    }
    this.getSearchResultsWithType(searchTerm);
  }

  getSearchResults(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();

    this.predictiveSearchResults.classList.add('loading');

    fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=product,collection,article,query&${encodeURIComponent('resources[limit]')}=100&section_id=predictive-search`)
      .then((response) => {
        this.predictiveSearchResults.classList.remove('loading');
        if (!response.ok) {
          var error = new Error(response.status);
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;

        this.renderSearchResults(resultsMarkup);
      })
      .catch((error) => {
        throw error;
      });
  }

  getSearchResultsWithType(searchTerm) {
    const queryKey = searchTerm.replace(" ", "-").toLowerCase();
    const type = ["product","collection","article","query"]

    // this.predictiveSearchResults.classList.add('loading');
    Promise.all(type.map((item) => {
      return fetch(`${theme.routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${item}&${encodeURIComponent('resources[limit]')}=${window.predictive_limit[item] || 3}&section_id=predictive-search`).then((response) => {
        return response.text()
      })
    })).then((arr = []) => {
      arr.map((item, index) => {
        const resultsMarkup = new DOMParser().parseFromString(item, 'text/html').querySelector('#shopify-section-predictive-search');
        this.renderSearchResultsWithType(resultsMarkup, type[index]);
        this.total += Number(resultsMarkup.querySelector('[data-result-total]')?.dataset?.resultTotal);

      })
      this.predictiveSearchResults.classList.remove('loading');
      this.actionAfterRenderResult();
    })
  }

  renderSearchResults(resultsMarkup) {
    this.predictiveSearchResults.innerHTML = resultsMarkup;

    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
    window.webyzeMultiProductColorsLoad?.();
  }

  renderSearchResultsWithType(resultsMarkup, type) {
    const originElement = this.predictiveSearchResults.querySelector(`[data-predictive-search-${type}`);
    const newElement = resultsMarkup.querySelector(`[data-predictive-search-${type}`);
    let products = JSON.parse(JSON.parse(resultsMarkup.querySelector('#product-with-qty')?.innerHTML));
    if(type === 'product' && products) { 
      products = products.sort((a, b) => a.quantity - b.quantity);
      console.log(products)
      const productElements = newElement.querySelectorAll('[data-predictive-product-id]');

      const fragment = document.createDocumentFragment();

      products.forEach(product => {
        const matchingElement = Array.from(productElements).find(el => el.getAttribute('data-predictive-product-id') === product.id);
        if (matchingElement) {
          fragment.appendChild(matchingElement);
        }
      });

      const productContainer = newElement.querySelector('.products');

      if (productContainer) {
        productContainer.innerHTML = ''; 
        productContainer.appendChild(fragment);
      }

    }
    if (originElement && newElement) {
      originElement.innerHTML = newElement.innerHTML;
    }
  }

  actionAfterRenderResult() {
    let _this = this,
      submitButton = this.container.querySelector('#search-results-submit');

    if (document.body.classList.contains('animations-true')) {
      gsap.to(this.predictiveSearchResults.querySelectorAll('.product-card .product-featured-image-link'), { scale: 1, opacity: 1, stagger: 0.15, ease: window.theme.settings.animation_easing });
    }
    submitButton.classList[this.total ? 'remove' : 'add']('hidden');
    
    submitButton.addEventListener('click', () => {
      _this.form.submit();
    });
    window.webyzeMultiProductColorsLoad?.();
    this.total = 0;
  }

  close() {
    this.container.classList.remove('active');
  }
}
window.addEventListener('load', () => {
  if (typeof PredictiveSearch !== 'undefined') {
    new PredictiveSearch();
  }
});